<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="specimenCase">
      <specimen-form
        :isLoading="isLoading"
        :specimenCase="specimenCase"
        :onSubmit="onSubmit">
      </specimen-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenForm from './SpecimenForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { caseSpecimenService } = biobankRegistry;

export default {
  name: 'SpecimenUpdate',
  components: {
    SpecimenForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Specimen Type',
      enableBackButton: true,
    },
    specimenCase: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const specimenData = await caseSpecimenService.getOne({ id });
    this.specimenCase = specimenData;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.specimen || {}, dataChange);
      data.isEdit = true;
      this.isLoading = true;
      try {
        await caseSpecimenService.update({ specimen: data });

        const { barcodeAttachment, id: specimenId } = data;
        if (barcodeAttachment) {
          const formData = new FormData();
          formData.append('attachment', barcodeAttachment[0]);
          await caseSpecimenService.uploadBarcode({ id: specimenId, formData });
        }

        this.$snackbar.showOk({ text: 'Successfully updated specimen!' });

        this.$router.push({ name: 'specimen.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
